import { call, take, put } from 'redux-saga/effects';
import axios               from 'axios';
import { SET_USER_VIDEOS } from 'actions/contentActions';
//import mockTutorials       from '../content/mockContent/tutorials';

const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/getUserVideos.php';



function* getUserVideos(): Generator<any,any,any> {
  while(true) {
    try {

        const input = yield take('GET_USER_VIDEOS_SAGA');

        const { userEmail } = input.payload
        
        if (process.env.NODE_ENV === 'development') {

            yield put(SET_USER_VIDEOS([
              {
                 title:    'title1',
                 video_id: 'some_user_id_string'
              },
              {
                title:    'title2',
                video_id: 'some_user_id_string2'
              }
            ]))

        }
        if (process.env.NODE_ENV === 'production') {

          const res = yield call( axios.post, endpoint, { userEmail: userEmail });

            if (res && res.data && res.data.result) {
                
                yield put(SET_USER_VIDEOS( res.data.result ))

            }

            else {
              console.log("can't get user videos")
            }

        }
    }
    catch(err) {
      console.log('err  :  '+err);
    }
    finally {}
  }
}


export default getUserVideos;






